export const workflowActivityEn = {
  "cowork.workflow.activity.loading": "Checking agent activity…",
  "cowork.workflow.activity.unavailable": "Live status unavailable",
  "cowork.workflow.activity.idle": "Agent idle",
  "cowork.workflow.activity.processing": "Processing…",
  "cowork.workflow.activity.retrying": "Retrying…",
  "cowork.workflow.activity.waiting": "Waiting for your input",
  "cowork.workflow.activity.preparing": "Preparing workflow…",
  "cowork.workflow.activity.reviewing": "Reading documents…",
  "cowork.workflow.activity.extracting": "Extracting data…",
  "cowork.workflow.activity.savingExtraction": "Saving extracted data…",
  "cowork.workflow.activity.analysing": "Preparing figures…",
  "cowork.workflow.activity.savingOutputs": "Saving results…",
  "cowork.workflow.activity.validating": "Validating results…",
  "cowork.workflow.activity.generatingReport": "Generating report…",
  "cowork.workflow.activity.savingReport": "Saving report…",
  "cowork.workflow.activity.buildingDashboard": "Building dashboard…",
  "cowork.workflow.activity.savingDashboard": "Saving dashboard…",
  "cowork.workflow.activity.coordinating": "Coordinating agents…",
  "cowork.workflow.activity.thinking": "Thinking…",
  "cowork.workflow.activity.responding": "Preparing response…",
  "cowork.workflow.activity.saved": "Saved results available",
  "cowork.workflow.activity.active": "Agent working on this step",
} as const

export const workflowActivityEt: Record<keyof typeof workflowActivityEn, string> = {
  "cowork.workflow.activity.loading": "Agendi tegevust kontrollitakse…",
  "cowork.workflow.activity.unavailable": "Reaalajas olek pole saadaval",
  "cowork.workflow.activity.idle": "Agent ootab ülesannet",
  "cowork.workflow.activity.processing": "Töötlemine…",
  "cowork.workflow.activity.retrying": "Proovitakse uuesti…",
  "cowork.workflow.activity.waiting": "Ootab sinu vastust",
  "cowork.workflow.activity.preparing": "Töövoo ettevalmistamine…",
  "cowork.workflow.activity.reviewing": "Dokumentide lugemine…",
  "cowork.workflow.activity.extracting": "Andmete eraldamine…",
  "cowork.workflow.activity.savingExtraction": "Eraldatud andmete salvestamine…",
  "cowork.workflow.activity.analysing": "Summade ettevalmistamine…",
  "cowork.workflow.activity.savingOutputs": "Tulemuste salvestamine…",
  "cowork.workflow.activity.validating": "Tulemuste kontrollimine…",
  "cowork.workflow.activity.generatingReport": "Aruande koostamine…",
  "cowork.workflow.activity.savingReport": "Aruande salvestamine…",
  "cowork.workflow.activity.buildingDashboard": "Töölaua koostamine…",
  "cowork.workflow.activity.savingDashboard": "Töölaua salvestamine…",
  "cowork.workflow.activity.coordinating": "Agentide töö koordineerimine…",
  "cowork.workflow.activity.thinking": "Mõtlemine…",
  "cowork.workflow.activity.responding": "Vastuse ettevalmistamine…",
  "cowork.workflow.activity.saved": "Salvestatud tulemused on saadaval",
  "cowork.workflow.activity.active": "Agent töötab selle etapi kallal",
}

export const workflowActivityRu: Record<keyof typeof workflowActivityEn, string> = {
  "cowork.workflow.activity.loading": "Проверка действий агента…",
  "cowork.workflow.activity.unavailable": "Текущий статус недоступен",
  "cowork.workflow.activity.idle": "Агент ожидает задачу",
  "cowork.workflow.activity.processing": "Обработка…",
  "cowork.workflow.activity.retrying": "Повторная попытка…",
  "cowork.workflow.activity.waiting": "Ожидание вашего ответа",
  "cowork.workflow.activity.preparing": "Подготовка рабочего процесса…",
  "cowork.workflow.activity.reviewing": "Чтение документов…",
  "cowork.workflow.activity.extracting": "Извлечение данных…",
  "cowork.workflow.activity.savingExtraction": "Сохранение извлечённых данных…",
  "cowork.workflow.activity.analysing": "Подготовка показателей…",
  "cowork.workflow.activity.savingOutputs": "Сохранение результатов…",
  "cowork.workflow.activity.validating": "Проверка результатов…",
  "cowork.workflow.activity.generatingReport": "Формирование отчёта…",
  "cowork.workflow.activity.savingReport": "Сохранение отчёта…",
  "cowork.workflow.activity.buildingDashboard": "Создание панели показателей…",
  "cowork.workflow.activity.savingDashboard": "Сохранение панели показателей…",
  "cowork.workflow.activity.coordinating": "Координация работы агентов…",
  "cowork.workflow.activity.thinking": "Анализ…",
  "cowork.workflow.activity.responding": "Подготовка ответа…",
  "cowork.workflow.activity.saved": "Сохранённые результаты доступны",
  "cowork.workflow.activity.active": "Агент работает над этим этапом",
}
